import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start px-2 w-[40rem] self-center" }
const _hoisted_2 = { class: "flex space-x-10 mt-4" }
const _hoisted_3 = { class: "mt-10 flex justify-center items-center w-full space-x-10" }

import {
	Input,
	ModalCloseButton,
	ModalContainer,
	ModalContentContainer,
	ModalButton,
	H1,
} from "../atoms"

import { PropType, reactive, ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateUserModal',
  props: {
	updateUser: {
		type: Function as PropType<(user: any) => void>,
		required: true,
	},
},
  setup(__props) {

/* eslint-disable  no-useless-escape */
let username = ref("")
let email = ref("")
let validationError = ref(false)
let showButton = ref(false)

const user = reactive({
	email: "",
	username: "",
})

const getUsername = () => {
	user.username = username.value

	if (user.username != "") {
		showButton.value = true
	} else {
		showButton.value = false
		user.username = ""
	}
}

const getEmail = () => {
	validationError.value = false

	const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email.value)

	if (regex) {
		user.email = email.value
		showButton.value = true
	} else {
		validationError.value = true
		showButton.value = false
		user.email = ""
	}
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ModalContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ModalContentContainer), {
        w: "50rem",
        h: "20rem"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(H1), { class: "text-v_dark_blue" }, {
              default: _withCtx(() => [
                _createTextVNode("Atualizar Usuário")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(Input), {
                placeholder: "Nome de Usuário:",
                type: "text",
                modelValue: _unref(username),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(username) ? (username).value = $event : username = $event)),
                onKeyup: getUsername
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(Input), {
                placeholder: "Email:",
                type: "email",
                modelValue: _unref(email),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(email) ? (email).value = $event : email = $event)),
                onKeyup: getEmail,
                class: _normalizeClass(_unref(validationError) && '!border-v_red border-2')
              }, null, 8, ["modelValue", "class"])
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(ModalCloseButton), {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeModal', false))),
              class: "active:scale-90"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cancelar ")
              ]),
              _: 1
            }),
            _createVNode(_unref(ModalButton), {
              enableButton: _unref(showButton),
              class: "active:scale-90",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (__props.updateUser(user))),
              disabled: !_unref(showButton)
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Atualizar ")
              ]),
              _: 1
            }, 8, ["enableButton", "disabled"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})